import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  homeRoot: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  headerSection: {
    paddingTop: "15px",
    paddingBottom: "15px",
    backgroundColor: "#fff",
  },
  headerTextSection: {
    color: "#b92034",
    textAlign: "left",
    width: "250px",
    fontWeight: "Bolder",
    fontSize: "28px",
    marginLeft: "10%",

  },

  containerDiv: {
    flex: "auto",
    position: "fixed",
    top: "40%",
    left: "42.5%",
  },
  extraBtnStyle: {
    margin: "2%",
    color: "#fff",
    fontWeight: "Bolder",
    fontSize: "28px",
  },
  centerItem: {
    flex: "auto",
    top: "15%",
    position: "relative",

    marginBottom: "10%",
    marginTop: "10%",
  },
  cardItem: {
    paddingTop: "30px",
  },
  fullWidth: {
    width: "80%",
    marginBottom: "25px",
    marginTop: "20px",
  },
  linkContainer: {
    marginBottom: "20px",
  },
  authResponse: {
    fontWeight: "bolder",
  },
  title: {
    flexGrow: 1,
  },
  fullWidthProfile: {
    width: "70%",
    marginRight: "15%",
    marginLeft: "15%",
    marginTop: "80px",
  },
  link: {
    color: "white",
    textDecoration: "none",
  },
  primary: {
    color: "#67a8e4",
  },
  customButton: {
    marginTop: "15px",
    marginBottom: "30px",
    backgroundColor: "#67a8e4",
    textTransform: "Capitalize",
    clear: "both",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingLeft: "30px",
    paddingRight: "30px",

    "&:hover": {
      background: "#67a8e4",
    },
  },
addButton:{
  marginTop: "0px!important",
},
  menuButton: {
    backgroundColor: "none",
    textTransform: "Capitalize",
    clear: "both",
    padding: "0px",
    verticleAlign: "middle",
    width: "100%",

    paddingRight: "15px",
    paddingLeft: "15px",

    "&:hover": {
      background: "#19537c",
    },
  },
  SubChildAnchor: {
    paddingRight: "15px",
    paddingLeft: "15px",
  },
  customButtonLeft: {
    float: "right",
    marginRight: "10%",
  },
  roundIcon: {
    backgroundColor: "white",
    borderRadius: "50%",
    color: "#67a8e4",
  },
  roundIconMenu: {
    borderRadius: "40%",
    lineHeight: "30px",
    verticalAlign: "middle",
    color: "#fff",
    position: "absolute",
    right: "5px",
    bottom: "10px",
    marginLeft: "30px",
  },
  roundIconMenuLeft: {
    verticalAlign: "middle",
    color: "#fff",
  },
  customLink: {
    color: "#fff",
    textDecoration: "none",
  },
  customLinkDark: {
    color: "#404346",
    textDecoration: "none",
  },
  customClear: {
    position: "relative",
    top: "40%",
    clear: "both",
    color: "#404346",
    fontSize: "16px",
  },
  customFail: {
    color: "#ef5350",
  },
  customSuccess: {
    color: "#4caf50",
  },
  bodyWrapper: {
    marginTop: "110px",
  },
  LoginLogoutBar: {
    color: "#67a8e4",
    fontSize: "18px",
  },
  sideNavbar: {
    paddingTop: "15px",
    backgroundColor: "#10649f",
    position: "fixed",
    left: "0",
    width: "230px",
    height: "calc(100%)",
    opacity: 1,
    textAlign: "left",
  },
  mCustomScrollBox: {
    position: "relative",
    overflow: "hidden",
    height: "100%",
    maxWidth: "100%",
    outline: "none",
    direction: " ltr",
  },
  mCSB_container: {
    position: "relative",
    top: "-9px",
    left: "0px",
  },
  logoWholeWapper: {
    textAlign: "center",
  },
  brandBig: {
    paddingTop: "30px",
    paddingBottom: "30px",
    lineHeight: "60px",
  },
  site_title_main: {
    display: "inline",
  },
  mCS_img_loaded: {
    verticalAlign: "middle",
    borderStyle: "none",
  },
  sideNavbarWrapper: {},
  listUnstyled: {
    listStyle: "none",

    paddingLeft: "0px",
  },
  generalList: {
    position: "relative",
  },
  subUl: {
    position: "relative",
    left: "0",
    marginTop: "5px",
    marginBottom: "5px",
    padding: "0px",
    background: "none",
    listStyle: "none",
  },

  dropdownLi: {
    color: "#fff",
  },
  generalLi: {
    color: "#fff",
    paddingTop: "5px",
    paddingBottom: "5px",
    textAlign: "left",
    width: "100%",
    lineHeight: "34px",
  },
  sidebar_active: {
    background: "#19537c",
  },
  // collapse:{
  //   display: "none"
  // }
  MuiDataGrid_windowContainer: {
    height: "900px",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  rightSideContent: {
    marginTop: "15px",
  },
  beforeLoad: {
    paddingTop: "45px",
    paddingBottom: "45px",
  },
  phoneInputClass: {
    width: "80%",
  },
  padding: {
    padding: theme.spacing(3),
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
    '@media (max-width: 500px)': {
      width: "90%!important",
      margin: "5%!important",
    },
  },
  demo2: {
    backgroundColor: "#2e1534",
  },
  dropzoneParagraphClass: {
    fontSize: "18px!important",
    position: "absolute",
    left: "50%!important",
    top: "10%!important",
    transform: "translate(-50%,-5%)!important",
  },
  switchRoot: {
    width: "50px!important",
    height: "24px!important",
    padding: "0px!important",
  },
  switchBase: {
    color: "#818181!important",
    padding: "1px!important",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#23bf58!important",
      },
    },
  },
  thumb: {
    color: "white!important",
    width: "20px!important",
    height: "20px!important",
    margin: "1px!important",
  },
  track: {
    borderRadius: "20px!important",
    backgroundColor: "#818181!important",
    opacity: "1 !important!important",
    "&:after, &:before": {
      color: "white!important",
      fontSize: "11px!important",
      position: "absolute!important",
      top: "6px!important",
    },
    "&:after": {
      content: "'Yes'",
      left: "8px!important",
    },
    "&:before": {
      content: "'No'",
      right: "7px!important",
    },
  },
  checked: {
    color: "#23bf58 !important",
    transform: "translateX(26px) !important",
  },
  customSpanLabel: {
    width: "75%!important",
  },
  last_name_wrapper: {
    marginLeft: "-15px!important",
    '@media (max-width: 500px)': {
      marginLeft: "0px!important",
    },
  },
  middle_name_wrapper:{
    '@media (max-width: 500px)': {
      marginLeft: "0px!important",
    },
  },
  searchBox:{
    '@media (max-width: 768px)': {
      marginBottom: "15px!important",
    },
  },
  fullWidthMobile:{
    '@media (max-width: 768px)': {
      width: "100%!important",
    },
  },
  first_name_wrapper: {
    marginLeft: "0px!important",
  },
  centerItemLogin: {
    flex: "auto",
    top: "15%",
    position: "relative",
    left: "33.33%",
    right: "33.33%",
    width: "33.33%",
    '@media (max-width: 500px)': { 
      left: "5%",
      right: "5%",
      width: "90%",
    },
    marginBottom: "10%",
    marginTop: "10%",
  },
  verticalGap:{
    '@media (max-width: 500px)': {
      marginTop:"20px"
    },
  },
  profileLabel:{
    textAlign:"left!important",
    paddingLeft:"15px"
  },
  editLabel:{
    textAlign: "left!important",
    paddingLeft: "15px",
    position:"absolute",
    right:"16.67%"
  },
  profileLink:{
  color:"#67a8e4",
  fontSize:"18px"
  }


}));
